<template>
  <button class="sns-button-wrapper" @click="getFacebookToken">
    <slot></slot>
  </button>
</template>

<script setup>
  import { setLibFile } from '@/common/utils/common'
  import { onMounted } from 'vue'

  const emit = defineEmits(['success', 'fail'])

  const getFacebookToken = () => {
    FB.login(
      function (facebookLoginResponse) {
        if (facebookLoginResponse.status === 'connected') {
          emit('success', {
            token: facebookLoginResponse.authResponse.accessToken,
          })
        }
      },
      { scope: 'public_profile', auth_type: 'reauthenticate' },
    )
  }

  onMounted(() => {
    // 페이스북 SDK 초기화
    window.fbAsyncInit = function () {
      FB.init({
        appId: '1818575348440201',
        status: true, // 로그인 상태를 확인
        cookie: true, // 쿠키가 세션을 참조할 수 있도록 허용
        xfbml: true, // 소셜 플러그인이 있으면 처리
        version: 'v4.0', // 버전 4.0 사용
      })
    }
    setLibFile(
      document,
      'script',
      'facebook-jssdk',
      '//connect.facebook.net/ko_KR/sdk.js',
    )
  })
</script>
